import axios from "axios"
import { env } from "../env"

// Ensure a sensible default baseURL so requests target the API root
const client = axios.create({
  baseURL: env.apiUrl,
  withCredentials: true,
})

// Attach token from localStorage if present
client.interceptors.request.use((cfg) => {
  try {
    const token = localStorage.getItem("token")
    if (token) {
      cfg.headers = cfg.headers || {}
      cfg.headers.Authorization = `Bearer ${token}`
    }
  } catch (_e) {
    // ignore
  }
  // Basic request logging
  try {
    // eslint-disable-next-line no-console
    const method = cfg.method ?? "get"
    const full = `${cfg.baseURL ?? ""}${cfg.url ?? ""}`
    console.debug("API request", method, full)
  } catch (_e) {
    // ignore
  }
  return cfg
})

// Optional: a lightweight response interceptor to normalize errors
client.interceptors.response.use(
  (res) => res,
  (err) => {
    // Re-throw a simpler error shape for consumers
    const error = err as any
    const message = error?.response?.data?.msg || error?.message || "API Error"
    // Log response error for debugging
    // eslint-disable-next-line no-console
    console.error(
      "API response error",
      err?.response?.status,
      err?.response?.data,
    )
    return Promise.reject(new Error(message))
  },
)

export default client
